exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".order-form .btn-disable,.order-form .btn-disable:hover{background-color:#d1d4d7!important;background:#d1d4d7!important;opacity:1}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/order/BaseForm.vue"],"names":[],"mappings":"AACA,wDACE,mCAAqC,AACrC,6BAA+B,AAC/B,SAAW,CACZ","file":"BaseForm.vue","sourcesContent":["\n.order-form .btn-disable , .order-form .btn-disable:hover {\n  background-color: #d1d4d7 !important;\n  background: #d1d4d7 !important;\n  opacity: 1;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fcf86e38","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/admin/order/BaseForm.vue
// module id = 1927
// module chunks = 0